import { GlobalFunction } from './../Services/public/globalFunction';
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Route,
} from '@angular/router';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';

@Injectable()
export class AgricolaGuard {
  constructor(
    private location: Location,
    private router: Router,
    public globalFunction: GlobalFunction
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const user = JSON.parse(window.localStorage.getItem('USER'));
    const url = state.url;

    const userTypesPermissions = {
      4: [
        { url: '/tareas', permission: 'prms_tasks_bool' },
        { url: '/admin', permission: 'prms_users_extra_bool' },
        { url: '/supervisores', permission: 'prms_users_extra_bool' },
        { url: '/monitor', permission: 'prms_users_extra_bool' },
        { url: '/fields', permission: 'prms_fields_bool' },
        { url: '/satelital', permission: 'prms_satellital_bool' },
      ],
      5: [
        { url: '/admin', permission: 'prms_admin_bool' },
        { url: '/supervisor', permission: 'prms_supervisor_bool' },
        { url: '/fields', permission: 'prms_fields_bool' },
        { url: '/satelital', permission: 'prms_satellital_bool' },
      ],
      6: [
        { url: '/reportes_individuales', permission: 'prms_reports_bool' },
        { url: '/monitor', permission: 'prms_monitors_bool' },
        { url: '/fields', permission: 'prms_fields_bool' },
        { url: '/tareas', permission: 'prms_tasks_bool' },
        { url: '/satelital', permission: 'prms_satellital_bool' },
      ],
      8: [
        { url: '/tareas', permission: 'prms_tasks_bool' },
        { url: '/admin', permission: 'prms_users_extra_bool' },
        { url: '/supervisores', permission: 'prms_users_extra_bool' },
        { url: '/monitor', permission: 'prms_users_extra_bool' },
        { url: '/fields', permission: 'prms_fields_bool' },
        { url: '/satelital', permission: 'prms_satellital_bool' },
      ],
      9: [
        { url: '/tareas', permission: 'prms_tasks_bool' },
        { url: '/admin', permission: 'prms_users_extra_bool' },
        { url: '/supervisores', permission: 'prms_users_extra_bool' },
        { url: '/monitor', permission: 'prms_users_extra_bool' },
        { url: '/fields', permission: 'prms_fields_bool' },
        { url: '/satelital', permission: 'prms_satellital_bool' },
      ],
    };

    if (userTypesPermissions[user.user_type]) {
      const permissions = userTypesPermissions[user.user_type];

      if (permissions) {
        const profile =
          user.user_type == 8 || user.user_type == 9
            ? JSON.parse(window.localStorage.getItem('access')).profile
            : user.profile;

        const noPermission = permissions.some(
          (p) => url.includes(p.url) && !profile[p.permission]
        );

        if (noPermission) {
          this.globalFunction.animation(
            'error',
            'No tienes permisos para acceder a esta página',
            'Error'
          );

          this.router.navigate(['/agricola/home']);
          return false;
        }
      }

      return true;
    }

    this.location.back();
    return false;
  }

  canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(next, state);
  }
}
